import React from 'react'
import SvgIcons from './SvgIcon'

export default props => {
  return (
    <SvgIcons {...props}>
      <path d="M21,13.3H3c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3h18c0.7,0,1.3,0.6,1.3,1.3S21.7,13.3,21,13.3z" />
      <path d="M21,7.3H3C2.3,7.3,1.8,6.7,1.8,6S2.3,4.8,3,4.8h18c0.7,0,1.3,0.6,1.3,1.3S21.7,7.3,21,7.3z" />
      <path d="M21,19.3H3c-0.7,0-1.3-0.6-1.3-1.3s0.6-1.3,1.3-1.3h18c0.7,0,1.3,0.6,1.3,1.3S21.7,19.3,21,19.3z" />
    </SvgIcons>
  )
}
